package com.arena_web.data.dto

import kotlinx.serialization.Serializable

@Serializable
data class UserPostDto(
    val id: String,
    val authorId: String,
    val content: String,
    val likesCount: Int,
    val isLikedByMe: Boolean,
    val commentsCount: Int = 0,
    val layout: Int = 1,
    val city: String? = null,
    val images: List<UserPostImageDto>,
    val createdAt: String,
    val updatedAt: String
)

@Serializable
data class UserPostImageDto(
    val id: String,
    val imageUrl: String,
    val sortOrder: Int
)

@Serializable
data class UserPostPageDto(
    val items: List<UserPostDto>,
    val page: Int,
    val size: Int,
    val totalItems: Long,
    val totalPages: Int
)

@Serializable
data class CreateUserPostRequest(
    val content: String = "",
    val imageUrls: List<String> = emptyList(),
    val layout: Int = 1,
    val city: String? = null
)

@Serializable
data class UserStoryDto(
    val id: String,
    val authorId: String,
    val imageUrl: String,
    val createdAt: String,
    val expiresAt: String,
    val likesCount: Long = 0,
    val isLikedByMe: Boolean = false,
    val viewsCount: Long = 0,
)

@Serializable
data class CreateUserStoryRequest(
    val imageUrl: String
)

/** One row of the story "Who saw this story?" sheet — a viewer's identity +
 *  mini player-card fields, plus whether they also liked the story. */
@Serializable
data class StoryViewerDto(
    val userId: String,
    val username: String,
    val fullName: String,
    val avatarUrl: String? = null,
    val cardImageUrl: String? = null,
    val cardAssetsBasePath: String? = null,
    val cardTextColor: String? = null,
    val cardAvatarUrl: String? = null,
    val likedByThem: Boolean = false,
)

// ── Comments ──────────────────────────────────────────────────────────────

@Serializable
data class UserPostCommentDto(
    val id: String,
    val postId: String,
    val authorId: String,
    val authorName: String,
    val authorAvatarUrl: String? = null,
    val authorCardImageUrl: String? = null,
    val authorCardAssetsBasePath: String? = null,
    val authorCardTextColor: String? = null,
    val authorCardAvatarUrl: String? = null,
    val content: String,
    val likesCount: Int,
    val isLikedByMe: Boolean,
    val createdAt: String,
)

@Serializable
data class UserPostCommentPageDto(
    val items: List<UserPostCommentDto>,
    val page: Int,
    val size: Int,
    val totalItems: Long,
    val totalPages: Int,
)

@Serializable
data class CreateUserPostCommentRequest(
    val content: String,
)

/** Server response for POST .../comments — only carries the new id. */
@Serializable
data class CreatedCommentIdDto(
    val id: String,
)
